import React from 'react';
import styles from './LoadingIndicator.module.scss';

export const LoadingIndicator = ({ message = 'Загрузка...' }: { message?: string }) => (
    <div className={styles.loadingOverlay}>
        <div className={styles.loadingContent}>
            <div className={styles.spinner}></div>
            {message && <div className={styles.message}>{message}</div>}
        </div>
    </div>
);